



















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import {
  GetCurrentUserData,
  PostChangeAccountName,
  PostPhoneCode,
  PostChangePhone,
  PostChangePassword,
} from "@/request/account";
import { validatePhoneNumber } from "@/utils/validator";
import { countDownTime } from "@/utils/count-down-time";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
import { User } from "@/types/user";
@Component({
  components: {
    Header,
    LeftNav,
    Copy,
  },
})
export default class AccountManage extends Vue {
  private user: User = { role: [] };
  private ifShowChangeAccountName: boolean = false;
  private newAccountName: string = "";
  private ifShowChangePhone: boolean = false;
  private waitTime: number = 60;
  private newPhone: string = "";
  private newRePhone: string = "";
  private phoneCode: string = "";
  private ifShowChangeEmail: boolean = false;
  private newEmail: string = "";
  private emailCode: string = "";
  private ifShowChangePassword: boolean = false;
  private newPassword: string = "";
  private renewPassword: string = "";
  /**
   * @description 获取用户信息
   */
  private fetchUserData(): void {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  /**
   * @description 自动计算角色
   */
  private calJuese(juese): string {
    let jigouText = "";
    juese.forEach((jigou: any) => {
      jigouText += jigou["名称"] + "-";
    });
    jigouText = jigouText.substring(0, jigouText.length - 1);
    return jigouText;
  }
  /**
   * @description 开始修改账户名
   */
  private startChangeAccountName(): void {
    this.ifShowChangeAccountName = true;
    this.newAccountName = "";
  }
  /**
   * @description 确认修改账户名
   */
  private confirmChangeAccountName(): void {
    const params = {
      新用户名: this.newAccountName,
    };
    PostChangeAccountName(this, params).then(() => {
      this.newAccountName = "";
      this.ifShowChangeAccountName = false;
      this.fetchUserData();
      this.$message.success("修改成功");
    });
  }
  /**
   * @description 开始修改手机号码
   */
  private startChangePhone(): void {
    this.ifShowChangePhone = true;
    this.phoneCode = "";
    this.newPhone = "";
    this.newRePhone = "";
  }
  /**
   * @description 获得验证码
   */
  private getCode(): void {
    const { valide, message } = validatePhoneNumber(this.newPhone);
    if (!valide) {
      this.$message.error(message);
    } else {
      PostPhoneCode(this, this.newPhone).then(() => {
        this.$message.success("发送成功");
        this.waitTime = 60;
        localStorage.setItem("waitTime", this.waitTime.toString());
        countDownTime(this, this.waitTime, "waitTime");
      });
    }
  }
  /**
   * @description 确认修改手机
   */
  private confirmChangePhone(): void {
    if (this.newPhone !== this.newRePhone) {
      this.$message.warning("两次输入的手机号不一致，请重新输入");
      return;
    }
    const reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!@#$%^&*\_\-?.])[a-zA-Z\d!#@*&.]{8,}$/;
    const passwordReg = reg.test(this.newPassword);
    // console.log(reg.test("As#1234567"));
    if (!passwordReg) {
      this.$message.warning(
        "密码长度必须8位以上，且包含英文大小写和数字以及特殊字符"
      );
      return;
    }
    const params = {
      新手机号: this.newPhone,
    };
    PostChangePhone(this, params)
      .then(() => {
        this.phoneCode = "";
        this.newPhone = "";
        this.newRePhone = "";
        this.ifShowChangePhone = false;
        this.fetchUserData();
        this.$message.success("修改成功");
      })
      .catch(() => {
        this.phoneCode = "";
      });
  }
  /**
   * @description 开始修改邮箱
   */
  private startChangeEmail(): void {
    this.ifShowChangeEmail = true;
    this.emailCode = "";
    this.newEmail = "";
  }
  /**
   * @description 获得邮箱验证码
   */
  private getEmailCode(): void {
    PostPhoneCode(this, this.user["手机号"]).then(() => {
      this.$message.success("发送成功");
      this.waitTime = 60;
      localStorage.setItem("waitTime", this.waitTime.toString());
      countDownTime(this, this.waitTime, "waitTime");
    });
  }
  /**
   * @description 确认绑定邮箱
   */
  private confirmChangeEmail(): void {
    // const params: any = {
    //   新手机号: this.newPhone,
    //   验证码: this.phoneCode
    // };
    // PostChangePhone(this, params)
    //   .then(() => {
    //     this.phoneCode = "";
    //     this.newPhone = "";
    //     this.ifShowChangePhone = false;
    //     this.fetchUserData();
    //     this.$message.success("修改成功");
    //   })
    //   .catch(() => {
    //     this.phoneCode = "";
    //   });
  }
  /**
   * @description 开始修改密码
   */
  private startChangePassword(): void {
    this.ifShowChangePassword = true;
    this.newPassword = "";
    this.renewPassword = "";
  }
  /**
   * @description 确定修改密码
   */
  private confirmChangePassword(): void {
    const reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!@#$%^&*\_\-?.])[a-zA-Z\d!#@*&.]{8,}$/;
    if (!this.newPassword) {
      this.$message.warning("新密码不能为空");
      return;
    }
    if (!this.renewPassword) {
      this.$message.warning("重复新密码不能为空");
      return;
    }
    if (!reg.test(this.newPassword)) {
      this.$message.warning(
        "密码长度必须8位以上，且包含英文大小写和数字以及特殊字符"
      );
      return;
    }
    if (this.newPassword !== this.renewPassword) {
      this.$message.error("两次输入的密码不一致，请重新输入");
      // this.newPassword = "";
      // this.renewPassword = "";
      return;
    }
    const params = {
      新密码: this.newPassword,
    };
    PostChangePassword(this, params).then(() => {
      this.$message.success("修改成功");
      this.newPassword = "";
      this.renewPassword = "";
      this.ifShowChangePassword = false;
    });
  }
  /**
   * @description 退出登录
   */
  private logout(): void {
    localStorage.removeItem("token");
    this.$router.push("/access/login");
  }
  /**
   * @description 初始化
   */
  private mounted(): void {
    this.waitTime = Number(localStorage.getItem("waitTime") || "0");
    if (this.waitTime !== 0) {
      countDownTime(this, this.waitTime, "waitTime");
    }
    this.fetchUserData();
  }
}
